const searchSuggestions = () => ({
  url: new URL(window.location.href),

  searchFormIsOpen: false,
  searchInput: document.querySelector("#search_input"),
  searchResults: [],
  searchQuerySuggestions: [],
  resultsCount: 0,
  currentSearchQuery: "",
  searchInputValue: "",
  searchForm: null,
  searchTrigger: null,
  init() {
    this.searchForm = document.querySelector(".js-search-form__container form")
    this.searchInput.addEventListener(
      "input",
      this.debounce((event) => {
        this.onChange(event)
      }, 300).bind(this)
    )

    //this.searchInputValue = this.url.searchParams.get('q')

    window.addEventListener("open-search", () => {
      this.searchTrigger = document.activeElement
      this.searchFormIsOpen = true
      setTimeout(()=> this.searchInput.focus(), 50)
      document.body.classList.add("overflow-hidden")
      document.documentElement.classList.add("search-open");
    })
    window.addEventListener("close-search", () => {
      this.searchFormIsOpen = false
      document.body.classList.remove("overflow-hidden")
      document.documentElement.classList.remove("search-open");
      this.resetSearchForm()
      const trigger = this.searchTrigger
      this.searchTrigger = null
      if (trigger && typeof trigger.focus === "function") {
        setTimeout(() => trigger.focus(), 50)
      }
    })
    window.addEventListener("keydown", (event) => {
      if (event.key !== "Escape" || !this.searchFormIsOpen) return
      event.preventDefault()
      window.dispatchEvent(new CustomEvent("close-search"))
    })

    if (this.searchInputValue) {
      this.getSearchResults(this.searchInputValue)
    }
  },
  resetSearchForm() {
    if (this.searchForm) {
      this.searchForm.reset()
      this.searchInputValue = ""
      this.searchResults = []
      this.searchQuerySuggestions = []
      this.resultsCount = 0
    }
    const container = document.getElementById("predictive-search-results-container")
    if (container) container.innerHTML = ""
  },
  onChange() {
    const searchTerm = this.searchInput.value
    const container = document.getElementById("predictive-search-results-container")

    if (!searchTerm.length) {
      this.searchResults = []
      this.searchQuerySuggestions = []
      this.resultsCount = 0
      this.currentSearchQuery = ""
      this.url.searchParams.delete("q")
      if (container) container.innerHTML = ""
      history.replaceState(
        {},
        null,
        window.location.origin + window.location.pathname
      )
      return
    }
    this.searchInputValue = searchTerm
    this.currentSearchQuery = `/search?q=${encodeURIComponent(searchTerm)}&type=product`
    this.url.searchParams.set("q", searchTerm)
    history.replaceState(null, null, "?q=" + searchTerm + "&type=product")

    this.getSearchResults(searchTerm)
  },
  getSearchResults(searchTerm) {
    const container = document.getElementById("predictive-search-results-container")
    if (!container) return

    const root = typeof window.Shopify !== "undefined" && window.Shopify.routes?.root ? window.Shopify.routes.root : "/"
    const url = `${root}search/suggest?q=${encodeURIComponent(searchTerm)}&resources[type]=query,product&resources[options][unavailable_products]=hide&resources[options][fields]=title,variants.title,product_type&resources[limit]=8&section_id=predictive-search-results`

    fetch(url)
      .then((response) => {
        if (!response.ok) throw new Error(`${response.status}: ${response.statusText}`)
        return response.text()
      })
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, "text/html")
        const section = doc.getElementById("shopify-section-predictive-search-results")
        if (section) {
          container.innerHTML = section.innerHTML
          if (window.Alpine) {
            window.Alpine.initTree(container)
          }
        }
      })
      .catch(() => {
        container.innerHTML = ""
      })
  },
  debounce(fn, wait) {
    let t
    return (...args) => {
      clearTimeout(t)
      t = setTimeout(() => fn.apply(this, args), wait)
    }
  },
})

export default searchSuggestions

document.addEventListener("alpine:init", () => {
  Alpine.data("searchSuggestions", searchSuggestions)
})